var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"barparent",staticStyle:{"height":"100vh"},attrs:{"src":_vm.url,"frameborder":"0","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }